import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    }
]

export const protectedRoutes = [
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/dashboards/default')),
    },
    {
        key: 'file-manager',
        path: `${APP_PREFIX_PATH}/file-manager`,
        component: React.lazy(() => import('views/app-views/file-manager')),
    },
    {
        key: 'videos',
        path: `${APP_PREFIX_PATH}/videos`,
        component: React.lazy(() => import('views/app-views/videos')),
    },
    {
        key: 'video-landings',
        path: `${APP_PREFIX_PATH}/video-landings`,
        component: React.lazy(() => import('views/app-views/video-landings')),
    },
    {
        key: 'admin.users',
        path: `${APP_PREFIX_PATH}/admin/users`,
        component: React.lazy(() => import('views/app-views/admin/users')),
    },
    {
        key: 'admin.auditoria',
        path: `${APP_PREFIX_PATH}/admin/auditoria`,
        component: React.lazy(() => import('views/app-views/admin/auditoria')),
    },
    {
        key: 'admin.roles',
        path: `${APP_PREFIX_PATH}/admin/roles`,
        component: React.lazy(() => import('views/app-views/admin/roles')),
    },
    {
        key: 'user.profile',
        path: `${APP_PREFIX_PATH}/user/profile`,
        component: React.lazy(() => import('views/app-views/user/default')),
    },
    {
        key: 'user.update-password',
        path: `${APP_PREFIX_PATH}/user/update-password`,
        component: React.lazy(() => import('views/app-views/user/default')),
    },
    {
        key: 'companies.company.index',
        path: `${APP_PREFIX_PATH}/companies`,
        component: React.lazy(() => import('views/app-views/companies/company')),
    },
    {
        key: 'persons.index',
        path: `${APP_PREFIX_PATH}/crm/contacts/persons`,
        component: React.lazy(() => import('views/app-views/contacts/persons')),
    },
    {
        key: 'persons.show',
        path: `${APP_PREFIX_PATH}/crm/contacts/persons/:id`, // <--- parámetro dinámico
        component: React.lazy(() => import('views/app-views/contacts/persons/PersonDetail')),
    },
    {
        key: 'persons.edit',
        path: `${APP_PREFIX_PATH}/crm/contacts/persons/:id/edit`, // <--- editar
        component: React.lazy(() => import('views/app-views/contacts/persons/PersonEdit')),
    },
    {
        key: 'persons.create',
        path: `${APP_PREFIX_PATH}/crm/contacts/persons/new`,
        component: React.lazy(() => import('views/app-views/contacts/persons/PersonCreate')),
    },
    {
        key: 'companies.company.show',
        path: `${APP_PREFIX_PATH}/companies/:id`, // <--- parámetro dinámico
        component: React.lazy(() => import('views/app-views/companies/company/CompanyDetail')),
    },
    {
        key: 'companies.company.edit',
        path: `${APP_PREFIX_PATH}/companies/edit/:id`, // <--- editar
        component: React.lazy(() => import('views/app-views/companies/company/CompanyEdit')),
    },
    {
        key: 'companies.company.create',
        path: `${APP_PREFIX_PATH}/companies/new`,
        component: React.lazy(() => import('views/app-views/companies/company/CompanyCreate')),
    },
    {
        key: 'companies.index',
        path: `${APP_PREFIX_PATH}/companies/prospectos`,
        component: React.lazy(() => import('views/app-views/companies/prospecto')),
    },
    {
        key: 'companies.show',
        path: `${APP_PREFIX_PATH}/companies/prospectos/:id`, // <--- parámetro dinámico
        component: React.lazy(() => import('views/app-views/companies/prospecto').then(m => ({ default: m.ProspectoDetail }))),
    },
    {
        key: 'companies.prospectos.edit',
        path: `${APP_PREFIX_PATH}/companies/prospectos/:id/edit`, // <--- editar
        component: React.lazy(() => import('views/app-views/companies/prospecto/ProspectosEdit')),
    },
    {
        key: 'companies.prospectos.create',
        path: `${APP_PREFIX_PATH}/companies/prospectos/nuevo`,
        component: React.lazy(() => import('views/app-views/companies/prospecto/ProspectoCreate')),
    },
    {
        key: 'persons.index',
        path: `${APP_PREFIX_PATH}/companies/clientes`,
        component: React.lazy(() => import('views/app-views/companies/clientes')),
    },
    {
        key: 'persons.show',
        path: `${APP_PREFIX_PATH}/companies/clientes/:id`, // <--- parámetro dinámico
        component: React.lazy(() => import('views/app-views/companies/clientes').then(m => ({ default: m.ClienteDetail }))),
    },
    {
        key: 'persons.clientes.edit',
        path: `${APP_PREFIX_PATH}/companies/clientes/:id/edit`, // <--- editar
        component: React.lazy(() => import('views/app-views/companies/clientes/ClientesEdit')),
    },
    {
        key: 'persons.clientes.create',
        path: `${APP_PREFIX_PATH}/companies/clientes/nuevo`,
        component: React.lazy(() => import('views/app-views/companies/clientes/ClienteCreate')),
    },
    {
        key: 'crm.kanban',
        path: `${APP_PREFIX_PATH}/crm`,
        component: React.lazy(() => import('views/app-views/crm')),
    },
    {
        key: 'crm.v2.index',
        path: `${APP_PREFIX_PATH}/crm-v2`,
        component: React.lazy(() => import('views/app-views/crm-v2')),
    },
    {
        key: 'crm.v2.board',
        path: `${APP_PREFIX_PATH}/crm-v2/board`,
        component: React.lazy(() => import('views/app-views/crm-v2/board/BoardPage')),
    },
    {
        key: 'crm.v2.pipelines',
        path: `${APP_PREFIX_PATH}/crm-v2/pipelines`,
        component: React.lazy(() => import('views/app-views/crm-v2/pipelines/PipelinesListPage')),
    },
    {
        key: 'crm.v2.pipelines.editor',
        path: `${APP_PREFIX_PATH}/crm-v2/pipelines/:id`,
        component: React.lazy(() => import('views/app-views/crm-v2/pipelines/PipelineEditorPage')),
    },
    {
        key: 'crm.v2.deals',
        path: `${APP_PREFIX_PATH}/crm-v2/deals`,
        component: React.lazy(() => import('views/app-views/crm-v2/board/redirects/ToSalesBoard')),
    },
    {
        key: 'crm.v2.deals.new',
        path: `${APP_PREFIX_PATH}/crm-v2/deals/new`,
        component: React.lazy(() => import('views/app-views/crm-v2/deals/DealCreatePage')),
    },
    {
        key: 'time-tracking.timesheet',
        path: `${APP_PREFIX_PATH}/time-tracking`,
        component: React.lazy(() => import('views/app-views/time-tracking/TimesheetPage')),
    },
    {
        key: 'time-tracking.projects',
        path: `${APP_PREFIX_PATH}/time-tracking/projects`,
        component: React.lazy(() => import('views/app-views/time-tracking/ProjectsPage')),
    },
    {
        key: 'time-tracking.projects.detail',
        path: `${APP_PREFIX_PATH}/time-tracking/projects/:id`,
        component: React.lazy(() => import('views/app-views/time-tracking/ProjectDetailPage')),
    },
    {
        key: 'time-tracking.team',
        path: `${APP_PREFIX_PATH}/time-tracking/team`,
        component: React.lazy(() => import('views/app-views/time-tracking/TeamPage')),
    },
    {
        key: 'time-tracking.approvals',
        path: `${APP_PREFIX_PATH}/time-tracking/approvals`,
        component: React.lazy(() => import('views/app-views/time-tracking/ApprovalsPage')),
    },
    {
        key: 'time-tracking.reports',
        path: `${APP_PREFIX_PATH}/time-tracking/reports`,
        component: React.lazy(() => import('views/app-views/time-tracking/ReportsPage')),
    },
    {
        key: 'time-tracking.reports.detail',
        path: `${APP_PREFIX_PATH}/time-tracking/reports/:companyId/:month`,
        component: React.lazy(() => import('views/app-views/time-tracking/ReportDetailPage')),
    },
    {
        key: 'time-tracking.report',
        path: `${APP_PREFIX_PATH}/time-tracking/report`,
        component: React.lazy(() => import('views/app-views/time-tracking/DevelopersReportPage')),
    },
    {
        key: 'time-tracking.report.developer',
        path: `${APP_PREFIX_PATH}/time-tracking/report/developer/:userId`,
        component: React.lazy(() => import('views/app-views/time-tracking/DeveloperDetailPage')),
    },
    {
        key: 'crm.v2.deals.list',
        path: `${APP_PREFIX_PATH}/crm-v2/deals/list`,
        component: React.lazy(() => import('views/app-views/crm-v2/deals/DealsListPage')),
    },
    {
        key: 'crm.v2.deals.detail',
        path: `${APP_PREFIX_PATH}/crm-v2/deals/:id`,
        component: React.lazy(() => import('views/app-views/crm-v2/deals/DealDetailPage')),
    },
    {
        key: 'crm.v2.leads',
        path: `${APP_PREFIX_PATH}/crm-v2/leads`,
        component: React.lazy(() => import('views/app-views/crm-v2/board/redirects/ToMarketingBoard')),
    },
    {
        key: 'crm.v2.leads.new',
        path: `${APP_PREFIX_PATH}/crm-v2/leads/new`,
        component: React.lazy(() => import('views/app-views/crm-v2/leads/LeadCreatePage')),
    },
    {
        key: 'crm.v2.leads.detail',
        path: `${APP_PREFIX_PATH}/crm-v2/leads/:id`,
        component: React.lazy(() => import('views/app-views/crm-v2/leads/LeadDetailPage')),
    },
    {
        key: 'crm.v2.recruitment',
        path: `${APP_PREFIX_PATH}/crm-v2/recruitment`,
        component: React.lazy(() => import('views/app-views/crm-v2/board/redirects/ToRecruitmentBoard')),
    },
    {
        key: 'crm.v2.recruitment.detail',
        path: `${APP_PREFIX_PATH}/crm-v2/recruitment/:id`,
        component: React.lazy(() => import('views/app-views/crm-v2/recruitment/PositionDetailPage')),
    },
    {
        key: 'crm.candidates',
        path: `${APP_PREFIX_PATH}/crm/contacts/candidates`,
        component: React.lazy(() => import('views/app-views/contacts/candidates')),
    },
    {
        key: 'crm.candidates.create',
        path: `${APP_PREFIX_PATH}/crm/contacts/candidates/nuevo`,
        component: React.lazy(() => import('views/app-views/contacts/candidates/CandidateCreate')),
    },
    {
        key: 'crm.candidates.detail',
        path: `${APP_PREFIX_PATH}/crm/contacts/candidates/:id`,
        component: React.lazy(() => import('views/app-views/contacts/candidates/CandidatesDetail')),
    },
    {
        key: 'crm.candidates.edit',
        path: `${APP_PREFIX_PATH}/crm/contacts/candidates/:id/edit`,
        component: React.lazy(() => import('views/app-views/contacts/candidates/CandidatesEdit')),
    },
    {
        key: 'crm.prospectos',
        path: `${APP_PREFIX_PATH}/crm/contacts/prospectos`,
        component: React.lazy(() => import('views/app-views/contacts/prospectos')),
    },
    {
        key: 'crm.prospectos.create',
        path: `${APP_PREFIX_PATH}/crm/contacts/prospectos/nuevo`,
        component: React.lazy(() => import('views/app-views/contacts/prospectos/ProspectCreate')),
    },
    {
        key: 'crm.prospectos.detail',
        path: `${APP_PREFIX_PATH}/crm/contacts/prospectos/:id`,
        component: React.lazy(() => import('views/app-views/contacts/prospectos/ProspectosDetail')),
    },
    {
        key: 'crm.prospectos.edit',
        path: `${APP_PREFIX_PATH}/crm/contacts/prospectos/:id/edit`,
        component: React.lazy(() => import('views/app-views/contacts/prospectos/ProspectosEdit')),
    },
    {
        key: 'crm.empleados',
        path: `${APP_PREFIX_PATH}/crm/contacts/empleados`,
        component: React.lazy(() => import('views/app-views/contacts/empleados')),
    },
    {
        key: 'crm.empleados.detail',
        path: `${APP_PREFIX_PATH}/crm/contacts/empleados/:id`,
        component: React.lazy(() => import('views/app-views/contacts/empleados/EmpleadosDetail')),
    },
    {
        key: 'crm.empleados.edit',
        path: `${APP_PREFIX_PATH}/crm/contacts/empleados/:id/edit`,
        component: React.lazy(() => import('views/app-views/contacts/empleados/EmpleadosEdit')),
    },
    {
        key: 'crm.empleados.create',
        path: `${APP_PREFIX_PATH}/crm/contacts/empleados/nuevo`,
        component: React.lazy(() => import('views/app-views/contacts/empleados/EmpleadosCreate')),
    },
    {
        key: 'crm.clientes',
        path: `${APP_PREFIX_PATH}/crm/contacts/clientes`,
        component: React.lazy(() => import('views/app-views/contacts/clientes')),
    },
    {
        key: 'crm.clientes.create',
        path: `${APP_PREFIX_PATH}/crm/contacts/clientes/nuevo`,
        component: React.lazy(() => import('views/app-views/contacts/clientes/ClientCreate')),
    },
    {
        key: 'crm.clientes.detail',
        path: `${APP_PREFIX_PATH}/crm/contacts/clientes/:id`,
        component: React.lazy(() => import('views/app-views/contacts/clientes/ClientesDetail')),
    },
    {
        key: 'crm.clientes.edit',
        path: `${APP_PREFIX_PATH}/crm/contacts/clientes/:id/edit`,
        component: React.lazy(() => import('views/app-views/contacts/clientes/ClientesEdit')),
    },
    {
        key: 'crm.oportunidades',
        path: `${APP_PREFIX_PATH}/crm/oportunidades`,
        component: React.lazy(() => import('views/app-views/crm/oportunidades')),
    },
    {
        key: 'crm.posiciones',
        path: `${APP_PREFIX_PATH}/crm/posiciones`,
        component: React.lazy(() => import('views/app-views/crm/posiciones')),
    },
    {
        key: 'crm.reclutamiento',
        path: `${APP_PREFIX_PATH}/crm/reclutamiento`,
        component: React.lazy(() => import('views/app-views/crm/reclutamiento')),
    },
    {
        key: 'comunicacion.campanas',
        path: `${APP_PREFIX_PATH}/comunicacion/campanas`,
        component: React.lazy(() => import('views/app-views/comunicacion/campanas')),
    },
    {
        key: 'comunicacion.campanas.create',
        path: `${APP_PREFIX_PATH}/comunicacion/campanas/new`,
        component: React.lazy(() => import('views/app-views/comunicacion/campanas/CampanasCreate')),
    },
    {
        key: 'comunicacion.campanas.edit',
        path: `${APP_PREFIX_PATH}/comunicacion/campanas/:id/edit`,
        component: React.lazy(() => import('views/app-views/comunicacion/campanas/CampanasEdit')),
    },
    {
        key: 'comunicacion.campanas.thread',
        path: `${APP_PREFIX_PATH}/comunicacion/campanas/:id/thread/:personId`,
        component: React.lazy(() => import('views/app-views/comunicacion/campanas/CampaignThread')),
    },
    {
        key: 'comunicacion.campanas.detail',
        path: `${APP_PREFIX_PATH}/comunicacion/campanas/:id`,
        component: React.lazy(() => import('views/app-views/comunicacion/campanas/CampanasDetail')),
    },
    {
        key: 'comunicacion.campanas.generated-emails',
        path: `${APP_PREFIX_PATH}/comunicacion/campanas/:id/generated-emails`,
        component: React.lazy(() => import('views/app-views/comunicacion/campanas/CampanasGeneratedEmails')),
    },
    {
        key: 'comunicacion.email-campaigns-v2',
        path: `${APP_PREFIX_PATH}/comunicacion/email-campaigns-v2`,
        component: React.lazy(() => import('views/app-views/comunicacion/email-campaigns-v2')),
    },
    {
        key: 'comunicacion.email-campaigns-v2.create',
        path: `${APP_PREFIX_PATH}/comunicacion/email-campaigns-v2/new`,
        component: React.lazy(() => import('views/app-views/comunicacion/email-campaigns-v2/EmailCampaignsV2Create')),
    },
    {
        key: 'comunicacion.email-campaigns-v2.detail',
        path: `${APP_PREFIX_PATH}/comunicacion/email-campaigns-v2/:id`,
        component: React.lazy(() => import('views/app-views/comunicacion/email-campaigns-v2/EmailCampaignsV2Detail')),
    },
    {
        key: 'comunicacion.listas',
        path: `${APP_PREFIX_PATH}/comunicacion/listas`,
        component: React.lazy(() => import('views/app-views/comunicacion/listas')),
    },
    {
        key: 'comunicacion.listas.create',
        path: `${APP_PREFIX_PATH}/comunicacion/listas/new`,
        component: React.lazy(() => import('views/app-views/comunicacion/listas/ListasCreate')),
    },
    {
        key: 'comunicacion.listas.detail',
        path: `${APP_PREFIX_PATH}/comunicacion/listas/:id`,
        component: React.lazy(() => import('views/app-views/comunicacion/listas/ListasDetail')),
    },
    {
        key: 'comunicacion.listas.edit',
        path: `${APP_PREFIX_PATH}/comunicacion/listas/:id/edit`,
        component: React.lazy(() => import('views/app-views/comunicacion/listas/ListasEdit')),
    },
    {
        key: 'scrapper.estado',
        path: `${APP_PREFIX_PATH}/scrapper/estado`,
        component: React.lazy(() => import('views/app-views/scrapper/estado')),
    },
    {
        key: 'scrapper.search-urls',
        path: `${APP_PREFIX_PATH}/scrapper/search-urls`,
        component: React.lazy(() => import('views/app-views/scrapper/search-urls')),
    },
    {
        key: 'scrapper.search-urls.detail',
        path: `${APP_PREFIX_PATH}/scrapper/search-urls/:id`,
        component: React.lazy(() => import('views/app-views/scrapper/search-urls/SearchUrlDetail')),
    },

]